import { gql } from "@apollo/client";

export const UPDATE_ALIMENTACION_ENTERAL = gql`
    mutation CreateAndUpdateAlimentacionEnteralRI(
        $screen: Int!
        $input: AddAlimentacionEnteralRIInput!)
    {
        createAndUpdateAlimentacionEnteralRI(
            screen: $screen
            input: $input
        ){
            idAlimentacionEnteralRI
        }
    }
`;